import { render, staticRenderFns } from "./DashboardDemandsSynthesis.vue?vue&type=template&id=39b5055c"
import script from "./DashboardDemandsSynthesis.vue?vue&type=script&lang=js"
export * from "./DashboardDemandsSynthesis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports